import { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useMatch } from 'react-router-dom-v5-compat';

import TicketForm from '~/components/Workflow/WorkflowTicketsPage/TicketCreatePage/WizardTicketForm/TicketForm';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { useIntl } from 'react-intl';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import WizardPageLayout from '~/ui/components/WizardPageLayout/WizardPageLayout';
import { copyToClipboard } from '~/utils/helper.utils';

// i18n-ignore: Not user facing string, tab values
const steps = ['Select Workflow', 'Create Ticket', 'Take Action'];

/* UX wants the title to take half of the space to the left of the Select Workflow header, which should be 325px. */
const TITLE_MAX_WIDTH = 325;

const WizardTicketForm = (props) => {
  const intl = useIntl();
  const [formState, setFormState] = useState({
    isSubmitDisabled: true,
    disabledSubmitTooltip: '',
  });

  const ticketFormRef = useRef();

  const handleCreateTicket = () => {
    ticketFormRef.current.onFormSubmit();
  };

  const { navigate, getSearchParam } = useRouting();
  const { contractRecordUniqueId } = useParams();

  const isIntegrateWorkflow = Boolean(
    useMatch(RoutePathType.IntegrateWorkflowIntakeFormLink),
  );

  const isAmendWorkflow = Boolean(
    useMatch(RoutePathType.IntegrateWorkflowAmendIntakeForm),
  );

  const referenceId = getSearchParam('reference_id');

  const handleClose = () => {
    navigate('/workflow/tickets');
  };

  const [copiedTooltip, setCopiedTooltip] = useState(false);
  const handleOnCopyAction = () => {
    setCopiedTooltip(true);
    copyToClipboard(window.location.href, null, null, handleCopiedTooltip);
  };

  const handleCopiedTooltip = () => {
    setTimeout(() => {
      setCopiedTooltip(false);
    }, 2000);
  };

  return (
    <WizardPageLayout
      // i18n-ignore: Not user facing string, tab value
      currentStep="Create Ticket"
      steps={steps}
      title={{ text: props.intakeForm.name, maxWidth: TITLE_MAX_WIDTH }}
      actionButton={{
        promise: handleCreateTicket,
        iconRight: 'arrowRight',
        text: intl.formatMessage({
          id: 'WorkflowIntakeFormLink.createTicketButton',
          defaultMessage: 'Create Ticket',
          description: 'Button text to create a new ticket',
        }),
        disabled:
          // TODO: refactor this, we need to remove this indirection (using ref to access child state is terrible. Really terribe.)
          !ticketFormRef.current?.state ||
          ticketFormRef.current?.state.isSubmittingForm ||
          ticketFormRef.current?.state.isLoadingForm,
        tooltip: formState.disabledSubmitTooltip,
      }}
      isContentCentered={false}
      onClose={handleClose}
      rightContent={
        <FlexLayout alignItems="center" space={4}>
          <IconButton
            icon="link"
            text={intl.formatMessage({
              id: 'WorkflowIntakeFormLink.copyLinkButton',
              defaultMessage: 'Copy Link',
              description: 'Button text to copy the intake form link',
            })}
            tooltip={
              copiedTooltip
                ? intl.formatMessage({
                    id: 'WorkflowIntakeFormLink.linkCopiedTooltip',
                    defaultMessage: 'Intake Form Link copied',
                    description:
                      'Tooltip shown after link is copied to clipboard',
                  })
                : intl.formatMessage({
                    id: 'WorkflowIntakeFormLink.copyLinkTooltip',
                    defaultMessage: 'Copy Intake Form Link',
                    description: 'Tooltip for copy link button',
                  })
            }
            onClick={handleOnCopyAction}
            id="copy"
          />
        </FlexLayout>
      }
    >
      <TicketForm
        ref={ticketFormRef}
        {...props}
        onUpdateFormState={setFormState}
        isIntegrateWorkflow={isIntegrateWorkflow}
        isAmendWorkflow={isAmendWorkflow}
        contractRecordUniqueId={contractRecordUniqueId}
        referenceId={referenceId}
      />
    </WizardPageLayout>
  );
};

const mapStateToProps = ({ intakeForm }) => ({ intakeForm });

export default connect(mapStateToProps)(WizardTicketForm);
